export const DashboardPage = () => import(/* webpackChunkName: "dashboard-page" */ "./pages/dashboard-page");
